(() => {
  if (customElements.get('product-selector')) return;

  class ProductSelector extends HTMLElement {
    constructor() {
      super();

      this.inputWrapper = '[data-input-wrapper]';

      const variantsJson = this.querySelector(
        'script[type="application/json"]'
      );

      try {
        this.variants = variantsJson
          ? JSON.parse(variantsJson.textContent || '[]')
          : [];
      } catch (error) {
        console.error('Kairos varyant verisi okunamadı:', error);
        this.variants = [];
      }

      this.form = document.querySelector(
        `#ProductForm-${this.dataset.sectionId}`
      );

      this.purchaseOptions = document.querySelector(
        `#Product-Purchase-Options-${this.dataset.sectionId}`
      );

      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.installmentsForm = this.dataset.installmentsFormId
        ? document.querySelector(this.dataset.installmentsFormId)
        : null;

      this.onVariantChange = this.onVariantChange.bind(this);
      this.addEventListener('change', this.onVariantChange);

      this.updateOptions();
      this.updateVariant();
      this.updateVariantStatuses();

      if (this.form && typeof this.form.toggleAddButton === 'function') {
        this.form.toggleAddButton(
          !this.currentVariant || !this.currentVariant.available,
          ''
        );
      }
    }

    getWrapperValue(wrapper) {
      if (!wrapper) return '';

      const checkedRadio = wrapper.querySelector(
        'input[type="radio"]:checked'
      );

      if (checkedRadio) return checkedRadio.value;

      const select = wrapper.querySelector('select');
      if (select) return select.value;

      const checkedOption = wrapper.querySelector('option:checked');
      return checkedOption ? checkedOption.value : '';
    }

    updateVariantStatuses() {
      const inputWrappers = Array.from(
        this.querySelectorAll(this.inputWrapper)
      );

      if (inputWrappers.length < 2 || !this.variants.length) return;

      const optionOneValue = this.getWrapperValue(inputWrappers[0]);
      if (!optionOneValue) return;

      const selectedOptionOneVariants = this.variants.filter(
        variant => variant.option1 === optionOneValue
      );

      inputWrappers.forEach((wrapper, index) => {
        if (index === 0) return;

        const previousOptionSelected = this.getWrapperValue(
          inputWrappers[index - 1]
        );

        const availableOptions = selectedOptionOneVariants
          .filter(variant => {
            if (!variant.available) return false;

            if (index === 1) {
              return variant.option1 === optionOneValue;
            }

            return (
              variant[`option${index}`] === previousOptionSelected
            );
          })
          .map(variant => variant[`option${index + 1}`]);

        const optionInputs = Array.from(
          wrapper.querySelectorAll('input[type="radio"], option')
        );

        optionInputs.forEach(input => {
          const inputIsDisabled = !availableOptions.includes(
            input.value
          );

          input.disabled = inputIsDisabled;

          if (input.tagName.toLowerCase() === 'option') {
            const dropdown = input.closest('dropdown-input');
            const dropdownButton = dropdown?.querySelector(
              `button[data-value="${CSS.escape(input.value)}"]`
            );

            if (dropdownButton) {
              dropdownButton.disabled = inputIsDisabled;
            }
          }

          if (!this.productBar) return;

          const inputId = input.dataset.id || input.id;
          if (!inputId) return;

          const productBarInput = this.productBar.querySelector(
            `option[data-id="${CSS.escape(inputId)}"]`
          );

          if (productBarInput) {
            productBarInput.disabled = inputIsDisabled;
          }
        });
      });
    }

    onVariantChange(event) {
      if (event.target.type === 'number') return;

      const previousVariantId = this.currentVariant?.id;

      this.updateOptions();
      this.updateVariant();

      if (
        previousVariantId &&
        this.currentVariant &&
        Number(previousVariantId) === Number(this.currentVariant.id)
      ) {
        return;
      }

      this.productBarUpdateOptions();
      this.updateVariantStatuses();
      this.updatePickupAvailability();

      if (this.form) {
        this.form.removeAttribute('data-has-selling-plan');

        if (typeof this.form.toggleAddButton === 'function') {
          this.form.toggleAddButton(false, '');
        }

        if (typeof this.form.handleErrorMessage === 'function') {
          this.form.handleErrorMessage();
        }
      }

      if (!this.currentVariant) {
        if (this.form && typeof this.form.toggleAddButton === 'function') {
          this.form.toggleAddButton(true, '');
        }

        this.setUnavailable();
        return;
      }

      if (!this.currentVariant.available) {
        if (this.form && typeof this.form.toggleAddButton === 'function') {
          this.form.toggleAddButton(
            true,
            window.variantStrings?.soldOut || 'Tükendi'
          );
        }
      }

      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();

      this.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            variant: this.currentVariant,
            options: this.options
          }
        })
      );
    }

    updateOptions() {
      this.querySelectorAll('input[type="radio"]').forEach(input => {
        const label = input.nextElementSibling;
        if (label) {
          label.classList.toggle('is-active', input.checked);
        }
      });

      this.options = Array.from(
        this.querySelectorAll('input[type="radio"]:checked, select'),
        element => ({
          name: element.dataset.name || element.name,
          value: element.value
        })
      );
    }

    productBarUpdateOptions() {
      if (!this.productBar) return;

      Array.from(this.productBar.querySelectorAll('select')).forEach(
        selector => {
          const matchingOption = this.options.find(
            option => option.name === selector.name
          );

          if (matchingOption) {
            selector.value = matchingOption.value;
          }
        }
      );
    }

    updateInventoryNotice(html) {
      const destination = document.querySelector(
        '[data-inventory-notice]'
      );
      const source = html.querySelector('[data-inventory-notice]');

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
    }

    updatePickupAvailability() {
      const pickupAvailability = document.querySelector(
        'pickup-availability'
      );

      if (!pickupAvailability || !this.currentVariant) return;

      pickupAvailability.dataset.variantId = this.currentVariant.id;

      if (this.currentVariant.available) {
        pickupAvailability.setAttribute('available', '');

        if (typeof pickupAvailability.fetchAvailability === 'function') {
          pickupAvailability.fetchAvailability(
            pickupAvailability.dataset.variantId
          );
        }

        return;
      }

      pickupAvailability.removeAttribute('available');
      pickupAvailability.innerHTML = '';
    }

    updateVariant() {
      this.currentVariant = this.getVariantData();
    }

    getVariantData() {
      if (!this.variants.length) return null;
      if (!this.options.length) return this.variants[0];

      return (
        this.variants.find(variant =>
          variant.options.every(
            (optionValue, index) =>
              this.options[index] &&
              this.options[index].value === optionValue
          )
        ) || null
      );
    }

    updateMedia() {
      if (!this.currentVariant?.featured_media) return;

      const productMedia = document.querySelector('product-media');

      if (productMedia && typeof productMedia.setActiveMedia === 'function') {
        productMedia.setActiveMedia(
          this.currentVariant.featured_media.id
        );
      }
    }

    updateURL(sellingPlanId) {
      if (!this.currentVariant) return;

      const params = new URLSearchParams(window.location.search);
      params.set('variant', this.currentVariant.id);

      if (sellingPlanId) {
        params.set('selling_plan', sellingPlanId);
      } else {
        params.delete('selling_plan');
      }

      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?${params.toString()}`
      );
    }

    updateVariantInput() {
      if (!this.currentVariant) return;

      /*
       * KRİTİK DÜZELTME:
       * Eski dosyada selector "[name=\"id\"" şeklinde eksikti.
       * Bu yüzden 7 mm / 8 mm seçimi formdaki varyant ID'sine yazılmıyordu.
       */
      const selectorVariantInput = this.querySelector(
        'input[name="id"]'
      );

      const installmentsVariantInput = this.installmentsForm?.querySelector(
        'input[name="id"]'
      );

      [selectorVariantInput, installmentsVariantInput].forEach(input => {
        if (!input) return;

        input.value = this.currentVariant.id;
        input.setAttribute('value', this.currentVariant.id);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    setUnavailable() {
      const submitButton = this.form?.submitButton;
      const price = document.querySelector(
        `#Product-Price-${this.dataset.sectionId}`
      );

      if (submitButton) {
        submitButton.textContent =
          window.variantStrings?.unavailable || 'Mevcut Değil';
      }

      if (price) {
        price.classList.add('visibility-hidden');
      }
    }

    renderProductInfo() {
      if (!this.currentVariant) return;

      const params = new URLSearchParams(window.location.search);
      params.set('variant', this.currentVariant.id);
      params.set('section_id', this.dataset.sectionId);

      fetch(`${this.dataset.url}?${params.toString()}`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );

          [
            `#Product-Price-${this.dataset.sectionId}`,
            `#Product-Purchase-Options-${this.dataset.sectionId}`
          ].forEach(selector => {
            const destination = document.querySelector(selector);
            const source = html.querySelector(selector);

            this.updateInventoryNotice(html);

            if (destination && source) {
              destination.classList.remove('visibility-hidden');
              destination.innerHTML = source.innerHTML;
            }
          });
        })
        .catch(error => {
          console.error('Kairos ürün bilgisi güncellenemedi:', error);
        });
    }
  }

  customElements.define('product-selector', ProductSelector);
})();
